export const getPostInstallationUrlWithQuery = ({
  appId,
  tenantId,
  instanceId,
  signedInstance,
  postInstallationUrl,
}: {
  appId: string;
  tenantId: string;
  instanceId: string | undefined;
  signedInstance?: string;
  postInstallationUrl: string;
}): string | undefined => {
  try {
    const url = new URL(postInstallationUrl);
    url.searchParams.set('appId', appId);
    url.searchParams.set('tenantId', tenantId);
    url.searchParams.set('instanceId', instanceId || '');
    if (signedInstance) {
      url.searchParams.set('signedInstance', signedInstance);
    }

    return url.toString();
  } catch (e) {
    return;
  }
};
